import { useAuth } from "../../contexts/AuthContext";

export default function DashboardHeader({ activeTab, onTabChange }) {
  const { logout } = useAuth();

  const tabs = [
    { key: "new", label: "📝 New Case" },
    { key: "existing", label: "🔍 Existing Patient" },
    { key: "excel", label: "📊 Excel Import/Export" },
    // { key: "appointments", label: "📅 Appointments" },
  ];

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      logout();
      window.location.href = "/"; // or useNavigate("/") if using react-router
    }
  };

  return (
    <header className="bg-green-700 text-white shadow-md">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between">
        <h1 className="text-2xl font-bold tracking-wide mb-3 sm:mb-0">
          Aarogyam Doctor Dashboard
        </h1>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          {/* Tabs */}
          <nav className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => onTabChange(tab.key)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
                  activeTab === tab.key
                    ? "bg-white text-green-700 shadow"
                    : "hover:bg-green-600"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium transition"
          >
            🔓 Logout
          </button>
        </div>
      </div>
    </header>
  );
}
